<template>
  <div class="sidebar"
       :data-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo">
      <a class="simple-text logo-mini" href="/">
        <div class="logo-img">
          <img :src="logo" alt="">
        </div>
      </a>
      <a class="simple-text logo-normal" href="/">{{ title }}
      </a>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink"></sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
import 'perfect-scrollbar/css/perfect-scrollbar.css'

const adminMenu = {
  name: 'Admin',
  icon: 'fa-star',
  collapsed: true,
  children: [{
    name: 'Users',
    path: '/admin/user'
  }, {
    name: 'Invite',
    path: '/admin/invite'
  }]
}

const superAdminMenu = {
  name: 'SuperAdmin',
  icon: 'nc-icon nc-spaceship',
  collapsed: true,
  children: [{
    name: 'Companies',
    nameI18n: {
      en: 'Companies',
      es: 'Empresas'
    },
    path: '/root/company'
  }, {
    name: 'Administrators',
    path: '/root/admin'
  }, {
    name: 'Login',
    path: '/'
  }, {
    name: 'Error test',
    path: '/someerror'
  }, {
    name: 'Home test',
    path: '/home'
  }]
}

const dashboardMenu = {
  name: 'Dashboard',
  icon: 'fa-cubes',
  // 'icon': 'fa-tachometer',
  path: '/dashboard/overview'
}

const menuAppDemoFamily = {
  name: 'Family',
  nameI18n: {
    en: 'Family',
    es: 'Familia'
  },
  icon: 'fa-cube',
  // 'icon': 'fa-users',
  collapsed: true,
  children: [{
    name: 'Families',
    path: '/apps/family'
  }, {
    icon: 'nc-icon nc-ruler-pencil',
    name: 'Families (sort)',
    path: '/demo/demo4'
  }]
}

// por ahora es necesario mantener name
const menuAppProjectManagement = {
  name: 'PM',
  icon: 'fa-cube',
  collapsed: true,
  children: [{
    name: 'Projects',
    nameI18n: {
      en: 'Projects',
      es: 'Projectos'
    },
    path: '/apps/pm/project'
  }, {
    name: 'Topics',
    nameI18n: {
      en: 'Topics',
      es: 'Tópicos'
    },
    path: '/apps/pm/topic'
  }, {
    name: 'Tasks',
    nameI18n: {
      en: 'Tasks',
      es: 'Tareas'
    },
    path: '/apps/pm/task'
  }, {
    name: 'Tasks (sort)',
    nameI18n: {
      en: 'Tasks (sort)',
      es: 'Tareas (ordernar)'
    },
    path: '/apps/pm/task-sort'
  }, {
    name: 'Gantt',
    path: '/apps/pm/gantt'
  }]
}

//
const menuAppLinks = {
  name: 'Links',
  nameI18n: {
      en: 'Links',
      es: 'Links'
    },
  icon: 'fa-cube',
  collapsed: true,
  children: [{
    name: 'Links',
    nameI18n: {
      en: 'Links',
      es: 'Links'
    },
    path: '/apps/links/link'
  }]
}

//
const menuAppCatalyst = {
  name: 'Cotizaciones',
  nameI18n: {
      en: 'Quotes',
      es: 'Cotizaciones'
    },
  icon: 'fa-cube',
  collapsed: true,
  children: [{
    name: 'Contact',
    nameI18n: {
      en: 'Contacts',
      es: 'Contactos'
    },
    path: '/apps/catalyst/contact'
  }, {
    name: 'Drafts',
    nameI18n: {
      en: 'Drafts',
      es: 'Borradores'
    },
    path: '/apps/catalyst/draft'
  }, {
    name: 'Cotizaciones',
    nameI18n: {
      en: 'Quotes',
      es: 'Cotizaciones'
    },
    path: '/apps/catalyst/quote'
  }]
}
//
const menuAppCatalystAdmin = {
  name: 'Cotizaciones ADMIN',
  nameI18n: {
    en: 'Quotes ADMIN',
    es: 'Cotizaciones ADMIN'
  },
  icon: 'fa-cube',
  collapsed: true,
  children: [{
    name: 'DayImages',
    nameI18n: {
      en: 'Day Images',
      es: 'Imágenes'
    },
    path: '/apps/catalyst/day-photo'
  }, {
    name: 'Incluye',
    nameI18n: {
      en: 'Included',
      es: 'Incluye'
    },
    path: '/apps/catalyst/incluye'
  }, {
    name: 'Categories',
    nameI18n: {
      en: 'Categories',
      es: 'Categorías'
    },
    path: '/apps/catalyst/category'
  }, {
    name: 'Items',
    nameI18n: {
      en: 'Available Items',
      es: 'Items generales'
    },
    path: '/apps/catalyst/item-available'
  }]
}

export default {
  props: {
    title: {
      type: String,
      default: 'Virtual-Bricks',
      // default: 'FileteJS',
      description: 'Sidebar title'
    },
    backgroundColor: {
      type: String,
      // default: 'white',
      default: 'black',
      validator: (value) => {
        const acceptedValues = ['white', 'brown', 'black']
        return acceptedValues.indexOf(value) !== -1
      },
      description: 'Sidebar background color (white|brown|black)'
    },
    activeColor: {
      type: String,
      default: 'success',
      // default: 'primary',
      validator: (value) => {
        const acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
        return acceptedValues.indexOf(value) !== -1
      },
      description: 'Sidebar active text color (primary|info|success|warning|danger)'
    },
    logo: {
      type: String,
      default: '/img/brickLogo1-128.png',
      // default: '/img/filete-logo.png',
      description: 'Sidebar Logo'
    },
    // en vez de obtener de un prop obtener del store para que sea caso a caso
    // sidebarLinks: {
    //   type: Array,
    //   default: () => [],
    //   description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
    // },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide () {
    return {
      autoClose: this.autoClose
    }
  },
  // data () {
  //   return {
  //     sidebarLinks: []
  //   }
  // },
  methods: {
    async initScrollBarAsync () {
      // const PerfectScroll = await import('perfect-scrollbar')
      // PerfectScroll.initialize(this.$refs.sidebarScrollArea)
    }
  },
  computed: {
    sidebarLinks: function () {
      // return []
      // let temp = this.$store.getters.getActiveSections
      const customData = this.$store.getters.getCustomData
      if (customData) {
        try {
          // return temp
          // let links = temp.currentCompanyData.activeSections.sidebarLinks
          const { accessData } = customData
          const links = []

          links.push(dashboardMenu)

          console.log('>>> debug 11111', accessData)

          if (accessData.apps.links) links.push(menuAppLinks)

          if (accessData.apps.catalyst) links.push(menuAppCatalyst)
          if (accessData.admin && accessData.apps.catalyst) links.push(menuAppCatalystAdmin)

          if (accessData.apps.projectManagement) links.push(menuAppProjectManagement)
          if (accessData.apps.family) links.push(menuAppDemoFamily)

          // @todo activar condición
          // if (accessData.apps.catalyst) links.push(menuAppCatalyst)

          if (accessData.admin) links.push(adminMenu)

          if (accessData.root) links.push(superAdminMenu)

          return links

          //         return [
          //   {
          //     name: 'Dashboard',
          //     icon: 'nc-icon nc-bank',
          //     path: '/admin/overview'
          //   },
          //   {
          //     name: 'Demo',
          //     icon: 'nc-icon nc-ruler-pencil',
          //     collapsed: true,
          //     children: [{
          //       name: 'Login',
          //       path: '/'
          //     }, {
          //       name: 'Families',
          //       path: '/demo/demo3'
          //     }, {
          //       name: 'Families (sort)',
          //       path: '/demo/demo4'
          //     },
          //     {
          //       name: 'People',
          //       path: '/demo/demo2'
          //     }
          //     ]
          //   }
          // ]
        } catch (e) {
          return []
        }
      } else {
        return 'No data'
      }
    }
  },
  mounted () {
    this.initScrollBarAsync()
  },
  beforeDestroy () {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false
    }
  }
}

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>
